/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { PureComponent } from 'react';
import withStyles from '@material-ui/core/styles/withStyles';
import Grid from '@material-ui/core/Grid';
import { Link } from 'react-router-dom';
import {
    arrayOf, object, string, shape, number, func,
} from 'prop-types';
import ReactMarkdown from 'react-markdown';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Product from '../../../GraphqlComponents/GraphqlCategoryPage/Partials/GraphqlProductContainer/Partials/GraphqlSimpleProduct/GraphqlSimpleProduct';
import { trackEvent as track } from '../../../../../state/ducks/TagManager/ducks/TagManager/TagManager-Actions';

const styles = (theme) => ({
    root: {
        flexGrow: 1,
    },
    container: {
        [theme.breakpoints.down('sm')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downSmall,
            margin: '20px auto',
            padding: '30px 2%',
        },
        [theme.breakpoints.up('sm')]: {
            padding: '2%',
        },
        [theme.breakpoints.down('md')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.downMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('md')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.upMedium,
            margin: '0 auto',
        },
        [theme.breakpoints.up('lg')]: {
            maxWidth: theme.palette.tiers?.container?.maxWidth?.upLarge,
            margin: '0 auto',
        },
    },
    product: {
        width: '300px',
    },
    mainContainer: {
        marginTop: '0',
        backgroundColor: theme.palette.tiers?.container?.backgroundColor,
    },
    titleWrapper: {
        display: 'flex',
        justifyContent: 'space-between',
        width: '100%',
        margin: '0',
        borderBottom: 'solid 1px #2f2f2f',
    },
    title: {
        width: '100%',
        color: theme.palette.cta1,
        flex: 1,
        '& h1,h2,h3,h4,h5,p': {
            textAlign: 'left',
            textTransform: 'uppercase',
            fontSize: '1.2em',
            display: 'block',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            margin: '0',
            padding: '0',
        },
        '& > a': {
            display: 'block',
            fontSize: '.8em',
        },
    },
    titleWrapperSolitary: {
        width: '100%',
        fontWeight: '400',
    },
    titleSolitary: {
        textAlign: 'center',
        '&::after': {
            content: '""',
            position: 'relative',
            borderBottom: 'solid 1px #2F2F2F',
            display: 'block',
            width: '100%',
            top: '-1.37em',
            zIndex: '-1',
        },
        '& h1,h2,h3,h4,h5,p': {
            color: theme.palette.cta1,
            flex: 1,
            margin: '0 auto',
            padding: '0 .5em',
            textTransform: 'uppercase',
            fontSize: '1.4em',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
            whiteSpace: 'nowrap',
            display: 'inline-block',
            position: 'relative',
            background: '#fff',
            fontWeight: '400',
        },

    },
    viewAll: {
        alignSelf: 'end',
        textDecoration: 'none',
        color: theme.palette.cta1,
        fontSize: '1em',
        position: 'relative',
        top: '.3em',
    },
    tierTitle: {
        position: 'absolute',
        bottom: 5,
        right: 0,
        left: 0,
        fontSize: '1em',
        fontWeight: 400,
        paddingLeft: 20,
        backgroundColor: theme.palette.tiers?.title.backgroundColor,
        textAlign: theme.palette.tiers?.title.upSmall.textAlign,
        lineHeight: theme.palette.tiers?.title.lineHeight,
        color: theme.palette.tiers?.title.color,
        [theme.breakpoints.down('sm')]: {
            lineHeight: 1.9,
            fontSize: 14,
            padding: 0,
            textAlign: theme.palette.tiers?.title.downSmall.textAlign,
        },
    },

    insideCard: {
        margin: 5,
        position: 'relative',
    },
    insideCardLink: {
        width: '100%',
    },
    reponsiveImage: theme.palette.tiers?.image,
    card: {
        backgroundColor: theme.palette.tiers?.card.backgroundColor,
        '& a p': {
            fontWeight: '400 !important',
            fontSize: '0.938em',
        },
        '& a p div': {
            fontWeight: '700 !important',
            fontSize: '1em',
        },
    },
});
class SubCollectionStandard extends PureComponent {
    getCard(brand, tier, productCount, isLast = false) {
        const { classes, trackEvent, trackData } = this.props;
        const {
            name = '', partNumber = '', seo = '', image = '', skuPriceRange = '', availability = '', prices = '', isPassportEligible = '',
        } = tier;
        return (
            <Grid className={classes?.card} key={tier?.name} item lg={(productCount < 5) ? 3 : 2} md={3} sm={4} xs={isLast ? 12 : 6}>
                <Product
                    partNumber={partNumber}
                    name={name}
                    prices={prices}
                    brand={brand}
                    image={image}
                    url={seo.url}
                    skuPriceRange={skuPriceRange}
                    availability={availability}
                    fromCategoryPage={typeof categoryData === 'object'}
                    track
                    isPassportEligible={isPassportEligible}
                    className={classes.product}
                    // skipAddons={skipAddons || false}
                    trackEvent={trackEvent}
                    trackData={trackData}
                    // featureFlags={featureFlags}
                    // sale={path === '/dealoftheweek-11905' ? 'SALE' : null}
                />
            </Grid>
        );
    }

    render() {
        const {
            data: {
                heading = '', collectionLink = '', products = '', brand = '',
            }, classes, trackData, trackEvent,
        } = this.props;
        const brandId = brand?.code;
        // TODO: Revert tempproducts to whatever count is returned when we can target device size
        // Ensures an even count of product is returned so mobile doesnt look goofy
        let tempproducts = products;
        if (products.length % 2) {
            // TODO: Revert this to whatever count is returned when we can target device size
            tempproducts = products.splice(1);
        }

        return (
            <Grid container direction="row" justify="center" alignItems="center" className={classes.container}>
                { /* if there is no link (e.g. View All) then render a center-justified header with decorative line */}
                {heading && !collectionLink ? (
                    <div className={classes.titleWrapperSolitary}>
                        <ReactMarkdown className={classes.titleSolitary} source={heading} />
                    </div>
                ) : ''}
                { /* ...otherwise show the heading title and place a link to the right side */}
                {heading && collectionLink ? (
                    <div className={classes.titleWrapper}>
                        <ReactMarkdown className={classes.title} source={heading} />
                        <Link
                            to={collectionLink}
                            className={classes.viewAll}
                            onClick={() => trackEvent({
                                eventLabel: trackData?.tracking_event_label,
                                eventCategory: trackData?.tracking_event_category,
                                eventAction: trackData?.tracking_event_action,
                                eventName: 'feature_interaction', // Requird for GA4 feature_click
                            })}
                        >VIEW ALL
                        </Link>
                    </div>
                ) : ''}

                <Grid className={classes.mainContainer} container spacing={4}>
                    { // products.map((tier) => (
                        tempproducts.map((tier) => (
                            this.getCard(brandId, tier, products.length)
                        ))
                    }
                </Grid>
            </Grid>
        );
    }
}

SubCollectionStandard.propTypes = {
    classes: object.isRequired,
    data: shape({
        heading: string,
        collectionLink: string,
        products: arrayOf(
            shape({
                id: string.isRequired,
                name: string.isRequired,
                image: shape({
                    name: string.isRequired,
                    path: string.isRequired,
                    url: string.isRequired,
                }).isRequired,
                prices: arrayOf(
                    shape({
                        value: number.isRequired,
                    }),
                ).isRequired,
                skuPriceRange: shape({
                    sale: arrayOf(
                        shape({
                            value: number.isRequired,
                        }),
                    ),
                    retail: arrayOf(
                        shape({
                            value: number.isRequired,
                        }),
                    ),
                }).isRequired,
                seo: shape({
                    url: string.isRequired,
                }).isRequired,
            }),
        ).isRequired,
    }).isRequired,
    trackEvent: func,
    trackData: shape({
        tracking_event_action: string,
        tracking_event_category: string,
        tracking_event_label: string,
    }),
    // ssrDeviceType: string.isRequired,
};

SubCollectionStandard.defaultProps = {
    trackData: {},
    trackEvent: () => {},
};

const mapDispatchToProps = (dispatch) => ({
    trackEvent: bindActionCreators(track, dispatch),
});

export default connect(
    null,
    mapDispatchToProps,
)(withStyles(styles)(SubCollectionStandard));
